export interface AuthParams {
    AppId: string;
    AppClientId: string;
    UserId: string;
    AccessToken: string;
    Address?: string;
}

export interface EmbeddedWalletsParams {
    Url: string;
}
export enum ChainType {
    Ethereum = "ethereum",
    Solana = "solana"
}
export enum RecoveryType {
    Base = "base_generated_recovery_key",
    UserPasscode = "user_passcode_recovery_key"
}
// export type ChainType = "ethereum" | "solana";
// export type RecoveryType = "base_generated_recovery_key" | "user_passcode_recovery_key"